import React from 'lib/react';
import PropTypes from 'prop-types';

function DashedLine({ color }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <g clipPath="url(#clip0_39981_145680)">
        <circle cx="5" cy="6" r="2" fill={color} />
        <path d="M0.0976562 6H12.0257" stroke={color} strokeWidth="2" strokeDasharray="2" />
      </g>
    </svg>
  );
}

DashedLine.propTypes = {
  color: PropTypes.string.isRequired,
};

export default DashedLine;
